export default "__VITE_ASSET___o9hz8Hg__"